var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookBw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.1668 42.6667V46.8333C50.1668 50.05 47.5502 52.6667 44.3335 52.6667H27.6668C24.4502 52.6667 21.8335 50.05 21.8335 46.8333V45.75C21.8335 43.1333 23.9668 41 26.5835 41H48.5002C49.4168 41 50.1668 41.75 50.1668 42.6667Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8335 19.3334H30.1668C23.5002 19.3334 21.8335 21 21.8335 27.6667V40.3C23.1002 39.1834 24.7668 38.5 26.5835 38.5H48.5002C49.4168 38.5 50.1668 37.75 50.1668 36.8334V27.6667C50.1668 21 48.5002 19.3334 41.8335 19.3334ZM37.6668 33.9167H29.3335C28.6502 33.9167 28.0835 33.35 28.0835 32.6667C28.0835 31.9834 28.6502 31.4167 29.3335 31.4167H37.6668C38.3502 31.4167 38.9168 31.9834 38.9168 32.6667C38.9168 33.35 38.3502 33.9167 37.6668 33.9167ZM42.6668 28.0834H29.3335C28.6502 28.0834 28.0835 27.5167 28.0835 26.8334C28.0835 26.15 28.6502 25.5834 29.3335 25.5834H42.6668C43.3502 25.5834 43.9168 26.15 43.9168 26.8334C43.9168 27.5167 43.3502 28.0834 42.6668 28.0834Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookBw);
export default __webpack_public_path__ + "static/media/book-bw.3f2c357c4511628666ce8725c5256c35.svg";
export { ForwardRef as ReactComponent };